<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import watermark from 'watermark-dom'
import { mapState } from 'vuex'
export default {
  name: 'App',
  computed:{
    ...mapState({
      userInfo: (state)=> state.user.userInfo
    })
  },
  watch:{
    userInfo:{
      handler(o,n){
        this.$nextTick(()=>{
          if(this.userInfo.id){
            watermark.init({watermark_txt:this.userInfo.userName,watermark_fontsize:'15px',watermark_alpha:0.07})
          // watermark.load({watermark_txt:this.userInfo.userName})
          }else{
            if(n&&n.id){
              watermark.remove()
              this.$router.go(0)
            }
          }
        })
      },
      deep: true,
      immediate: true
    }
  },
  mounted(){
    // document.onkeydown = () => {
    //   //禁用F12
    //   if (window.event && window.event.keyCode == 123) {
    //     return false;
    //   //禁用ctrl+shift+i,
    //   } else if (window.event.ctrlKey && window.event.shiftKey && window.event.keyCode == 73) {
    //     return false;
    //   //屏蔽Shift+F10
    //   } else if (window.event.shiftKey && window.event.keyCode == 121) {
    //     return false;
    //   }
    // };
    // var threshold = 100;
    // this.timer1 = setInterval(function () {
    //   //当浏览器窗口宽度或高度与页面的宽度和高度的差值大于100的时候触发页面刷新
    //   if (window.outerWidth - window.innerWidth > threshold || window.outerHeight - window.innerHeight > threshold) {
    //     // 刷新页面；
    //     window.location.reload()
    //     alert('请关闭控制台重新输入地址进入网站');
    //   }
    // },threshold)
  }
}
</script>

<style lang="less">
.ivu-modal-wrap{
  z-index: 999 !important;
}
.ivu-modal-mask{
  z-index: 999 !important;
}
.size {
  width: 100%;
  height: 100%;
}

html,
body {
  .size;
  overflow: hidden;
  margin: 0;
  padding: 0;
}

#app {
  .size;
}
</style>
